import MobileDetect from "mobile-detect"

const isMobile = (userAgent) => {
    const md = new MobileDetect(userAgent);

    return Boolean(md.mobile());
}

export default isMobile;
